import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, getDoc, doc, orderBy, limit, getDocs, Timestamp, setDoc, updateDoc } from 'firebase/firestore';
import { isModuleEnabled } from '../utils/saasConfig';
import BotonPanico from '../components/Safety/BotonPanico';
import moment from 'moment';
import {
  IoTicketOutline,
  IoCalendarOutline,
  IoWalletOutline,
  IoDocumentTextOutline,
  IoFileTrayFullOutline,
  IoWarningOutline,
  IoVideocamOutline,
  IoLogOutOutline,
  IoConstructOutline,
  IoMegaphoneOutline,
  IoCarSportOutline,
  IoPersonCircleOutline,
  IoPawOutline,
  IoCashOutline,
  IoStorefrontOutline,
  IoBriefcaseOutline,
  IoListCircleOutline,
  IoReceiptOutline,
  IoArrowForward,
  // eslint-disable-next-line no-unused-vars
  IoSearchOutline,
  IoSettingsOutline,
  IoPeopleOutline,
  IoChatbubblesOutline,
  IoShieldCheckmarkOutline,
  IoCubeOutline,
  IoArchiveOutline,
  IoLocationOutline,
  IoBusinessOutline,
  IoKeypadOutline,
  IoAnalyticsOutline,
  IoAppsOutline,
  IoNotificationsOutline,
  IoHomeOutline,
  IoCloseOutline,
  IoCalculatorOutline,
  IoStatsChartOutline,
  IoChevronForwardOutline,
  IoImageOutline,
  IoFolderOpenOutline,
  IoCardOutline,
  IoAlertCircleOutline,
  IoBanOutline,
  IoLockClosedOutline,
  IoLockOpenOutline
} from 'react-icons/io5';
import './HomeScreen.css';
import AvatarViewer from '../components/Shared/AvatarViewer';
import kondifyLogo from '../assets/Kondify letra negra sin fondo.png';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
// ─────────────────────────────────────────────────
//  AVISOS CAROUSEL (mobile-only, CSS scroll-snap)
// ─────────────────────────────────────────────────
const AvisosCarousel = ({ avisos, onVerTodos, actionLabel }) => {
  if (!avisos || avisos.length === 0) return null;

  return (
    <div className="ks-carousel-section">
      <div className="ks-carousel-header">
        <span className="ks-section-label" style={{ margin: 0 }}>Avisos</span>
        <button className="ks-carousel-ver-todos" onClick={onVerTodos}>
          {actionLabel || 'Ver todos'} <IoChevronForwardOutline size={13} />
        </button>
      </div>
      <div className="ks-carousel-track">
        {avisos.map((aviso) => {
          const isCritical = aviso.esAlerta && aviso.fechaExpiracionAlerta && (
            (aviso.fechaExpiracionAlerta.toDate ? aviso.fechaExpiracionAlerta.toDate() : new Date(aviso.fechaExpiracionAlerta)) > new Date()
          );
          return (
            <div 
              key={aviso.id} 
              className={`ks-aviso-card ${isCritical ? 'alerta' : ''}`} 
              onClick={onVerTodos}
              style={isCritical ? { background: '#fffbeb', border: '1px solid #fca5a5' } : {}}
            >
              <div 
                className={`ks-aviso-tipo-dot ${isCritical ? 'urgente' : (aviso.tipo || 'informativo')}`} 
                style={isCritical ? { background: '#ef4444' } : {}}
              />
              <div className="ks-aviso-body">
                <p className="ks-aviso-titulo" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  {isCritical && <IoWarningOutline size={14} color="#ef4444" />}
                  {aviso.titulo}
                </p>
                <p className="ks-aviso-preview">
                  {aviso.contenido ? aviso.contenido.substring(0, 55) + '…' : ''}
                </p>
              </div>
              <div className="ks-aviso-footer">
                <IoPersonCircleOutline size={15} />
                <span>{aviso.creadoPorNombre || 'Administración'}</span>
              </div>
            </div>
          );
        })}
        {/* Ghost card to show "more" */}
        <div className="ks-aviso-card ks-aviso-card-more" onClick={onVerTodos}>
          <IoMegaphoneOutline size={28} style={{ color: '#9B8CFF', marginBottom: 8 }} />
          <span>{actionLabel === 'Gestionar' ? 'Gestionar avisos' : 'Ver todos los avisos'}</span>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────
//  AMENIDADES CAROUSEL (mobile-only, hero image cards)
// ─────────────────────────────────────────────────
const AmenidadesCarousel = ({ amenidades, onExplorar }) => {
  if (!amenidades || amenidades.length === 0) return null;

  // Pastel placeholder gradients for amenidades without photos
  const placeholders = [
    'linear-gradient(135deg, #667eea, #764ba2)',
    'linear-gradient(135deg, #f093fb, #f5576c)',
    'linear-gradient(135deg, #4facfe, #00f2fe)',
    'linear-gradient(135deg, #43e97b, #38f9d7)',
    'linear-gradient(135deg, #fa709a, #fee140)',
  ];

  return (
    <div className="ks-carousel-section ks-amenidades-section">
      <div className="ks-carousel-header">
        <span className="ks-section-label" style={{ margin: 0 }}>Amenidades Destacadas</span>
        <button className="ks-carousel-ver-todos" onClick={onExplorar}>
          Explorar <IoChevronForwardOutline size={13} />
        </button>
      </div>
      <div className="ks-carousel-track ks-amenidades-track">
        {amenidades.slice(0, 6).map((amenidad, idx) => (
          <div
            key={amenidad.id}
            className="ks-amenidad-card"
            onClick={onExplorar}
            style={{
              backgroundImage: amenidad.fotoUrl
                ? `url(${amenidad.fotoUrl})`
                : 'none',
              background: amenidad.fotoUrl ? undefined : placeholders[idx % placeholders.length],
            }}
          >
            {amenidad.fotoUrl && (
              <img src={amenidad.fotoUrl} alt={amenidad.nombre} className="ks-amenidad-bg-img" />
            )}
            <div className="ks-amenidad-overlay">
              <div className="ks-amenidad-badge">
                {amenidad.bloqueadaPorAdmin ? 'Mantenimiento' : 'Disponible hoy'}
              </div>
              <div className="ks-amenidad-text">
                <p className="ks-amenidad-nombre">{amenidad.nombre}</p>
                <p className="ks-amenidad-desc">
                  {amenidad.descripcion ? amenidad.descripcion.substring(0, 30) + '…' : 'Zona Premium'}
                </p>
              </div>
              <div className="ks-amenidad-arrow">
                <IoArrowForward size={16} color="white" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────
//  HomeCard — Premium Minimal (shared component)
// ─────────────────────────────────────────────────
const HomeCard = ({ to, icon, title, subtitle, theme, disabled = false, onClick, badgeCount }) => {

  if (disabled) {
    return (
      <div className="ks-card disabled">
        <div className={`ks-card-icon ${theme}`}>{icon}</div>
        <div className="ks-card-body">
          <h3>{title}</h3>
        </div>
      </div>
    );
  }

  const content = (
    <>
      {badgeCount > 0 && (
        <div className="ks-card-badge">{badgeCount > 99 ? '99+' : badgeCount}</div>
      )}
      <div className={`ks-card-icon ${theme}`}>{icon}</div>
      <div className="ks-card-body">
        <h3>{title}</h3>
      </div>
    </>
  );

  if (onClick) {
    return <div className="ks-card" onClick={onClick}>{content}</div>;
  }

  return <Link to={to} className="ks-card">{content}</Link>;
};

// ─────────────────────────────────────────────────
//  HomeScreen
// ─────────────────────────────────────────────────
function HomeScreen() {
  const { currentUser, userData, logout, isMoroso, hasConvenio, setUserData } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (userData && userData.rol === 'trabajador') {
      navigate('/trabajador/dashboard', { replace: true });
    }
  }, [userData, navigate]);

  const [turnoConfirmModal, setTurnoConfirmModal] = useState({ show: false, isEntering: false });
  const [turnoSuccessModal, setTurnoSuccessModal] = useState({ show: false, message: '' });

  const handleToggleTurno = () => {
    setTurnoConfirmModal({
      show: true,
      isEntering: !userData?.enTurno
    });
  };

  const confirmToggleTurno = async () => {
    const isEntering = turnoConfirmModal.isEntering;
    setTurnoConfirmModal({ show: false, isEntering: false });

    const targetUid = userData?.isSimulated ? userData.uid : currentUser?.uid;
    if (!targetUid) return;

    try {
      const userRef = doc(db, 'usuarios', targetUid);
      await updateDoc(userRef, {
        enTurno: isEntering
      });

      setUserData(prev => ({
        ...prev,
        enTurno: isEntering
      }));

      setTurnoSuccessModal({
        show: true,
        message: isEntering ? "Tu turno de vigilancia ha sido iniciado con éxito." : "Tu turno de vigilancia ha finalizado."
      });
    } catch (e) {
      console.error("Error al cambiar turno:", e);
      alert("Error al actualizar el turno de vigilancia.");
    }
  };

  const getModuleInfo = (key) => {
    const infos = {
      'estacionamientos': {
        title: 'Estacionamientos de Visitas',
        description: 'Controla y asigna espacios de estacionamiento para visitas de forma digital, evitando conflictos y agilizando el registro en caseta.',
        benefits: ['Visualización en tiempo real de cajones disponibles', 'Auto-registro rápido de visitas mediante QR', 'Historial detallado de ocupación']
      },
      'paqueteria': {
        title: 'Gestión de Paquetería y Caseta',
        description: 'Lleva un registro ordenado de los paquetes y entregas de mensajería (Amazon, MercadoLibre, etc.) que llegan a la caseta de vigilancia.',
        benefits: ['Notificaciones instantáneas al residente al recibir un paquete', 'Firma digital de entrega', 'Historial y control de paquetes de forma ordenada']
      },
      'seguridad': {
        title: 'Rondines de Seguridad y Cámaras',
        description: 'Supervisa el trabajo de los guardias mediante rondines geolocalizados, checkpoints con QR, y monitoreo en vivo.',
        benefits: ['Trazado de rutas de guardias en mapa en tiempo real', 'Reportes de bitácoras de incidentes', 'Monitoreo e integración de cámaras de seguridad']
      },
      'licitaciones': {
        title: 'Licitaciones & Proyectos B2B',
        description: 'Crea concursos de obra y cotizaciones de servicios mayores para recibir propuestas directamente de proveedores validados.',
        benefits: ['Comparativa automática de propuestas', 'Transparencia de presupuestos del fraccionamiento', 'Contacto directo con red B2B certificada']
      },
      'apercibimientos': {
        title: 'Sanciones y Multas',
        description: 'Aplica apercibimientos y multas por infracciones al reglamento interno con evidencia fotográfica.',
        benefits: ['Registro fotográfico de la infracción', 'Generación automática de recargos', 'Apelaciones desde la app']
      },
      'finanzas/banco': {
        title: 'Conciliación Bancaria Inteligente',
        description: 'Automatiza el registro de ingresos y egresos vinculando tus cuentas bancarias directamente al sistema contable.',
        benefits: ['Lectura y emparejamiento automático de transferencias SPEI', 'Reducción de trabajo administrativo manual', 'Balance financiero al día']
      },
      'gestion-facturas': {
        title: 'Facturación Fiscal CFDI Automática',
        description: 'Emite facturas y comprobantes fiscales CFDI 4.0 de forma automática a los residentes tras el pago de sus cuotas.',
        benefits: ['Automatización con FacturAPI', 'Envío directo por correo', 'Cumplimiento fiscal sin esfuerzo manual']
      },
      'nominas-dashboard': {
        title: 'RH y Nómina Condominal',
        description: 'Controla el pago a empleados del fraccionamiento (mantenimiento, administración, seguridad), incidencias, e IMSS/ISN.',
        benefits: ['Dispersión de nómina directa', 'Cálculo de impuestos locales y federales', 'Expediente de empleados con incidencias']
      }
    };
    return infos[key] || {
      title: 'Módulo Premium',
      description: 'Esta funcionalidad de alta gama requiere una suscripción SaaS adicional para estar activa.',
      benefits: ['Optimización de procesos internos', 'Mayor transparencia y comunicación', 'Control integral del fraccionamiento']
    };
  };
  // ── Badge state ──────────────────────────────
  const [pendingReports, setPendingReports] = useState(0);
  const [pendingWallPosts, setPendingWallPosts] = useState(0);
  const [pendingVehicles, setPendingVehicles] = useState(0);
  const [pendingProviders, setPendingProviders] = useState(0);
  const [resPendingResponses, setResPendingResponses] = useState(0);
  const [pendingEncuestas, setPendingEncuestas] = useState(0);
  const [pendingAsambleas, setPendingAsambleas] = useState(0);
  const [pendingPackages, setPendingPackages] = useState(0);
  const [pendingParking, setPendingParking] = useState(0);
  const [pendingLicitaciones, setPendingLicitaciones] = useState(0);
  const [pendingGlobalValidations, setPendingGlobalValidations] = useState(0);
  const [pendingConvenios, setPendingConvenios] = useState(0);
  const [pendingSanciones, setPendingSanciones] = useState(0);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [globalBadgeCount, setGlobalBadgeCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);

  // ── SaaS Interest Voting & Locked Modals ─────
  const [votosInteres, setVotosInteres] = useState({});
  const [selectedLockedModule, setSelectedLockedModule] = useState(null);
  const [showLockedModal, setShowLockedModal] = useState(false);
  const [hasVoted, setHasVoted] = useState(false);
  const [votingLoader, setVotingLoader] = useState(false);

  useEffect(() => {
    if (!userData?.condominioId || userData?.condominioId === 'GLOBAL') return;
    
    const ref = collection(db, 'condominios', userData.condominioId, 'interes_modulos');
    const unsub = onSnapshot(ref, 
      (snap) => {
        const counts = {};
        snap.forEach(docSnap => {
          counts[docSnap.id] = docSnap.data().votosCount || 0;
        });
        setVotosInteres(counts);
      },
      (error) => {
        console.warn("No se pudieron cargar los votos de interés (SaaS):", error);
      }
    );

    return () => unsub();
  }, [userData]);

  const openLockedModuleModal = async (moduleKey) => {
    setSelectedLockedModule(moduleKey);
    setHasVoted(false);
    setShowLockedModal(true);

    if (!userData?.condominioId || !userData?.numeroCasa) return;

    try {
      const voteRef = doc(db, 'condominios', userData.condominioId, 'interes_modulos', moduleKey, 'votos', userData.numeroCasa);
      const snap = await getDoc(voteRef);
      if (snap.exists()) {
        setHasVoted(true);
      }
    } catch (e) {
      console.error("Error checking vote status:", e);
    }
  };

  const handleRegisterInterest = async () => {
    if (!userData?.condominioId || !userData?.numeroCasa || !selectedLockedModule) return;
    setVotingLoader(true);
    try {
      const voteRef = doc(db, 'condominios', userData.condominioId, 'interes_modulos', selectedLockedModule, 'votos', userData.numeroCasa);
      
      // Save vote (unique by numeroCasa)
      await setDoc(voteRef, {
        usuarioId: currentUser.uid,
        userName: userData.nombre || 'Residente',
        numeroCasa: userData.numeroCasa,
        timestamp: Timestamp.now()
      });

      // Update total counter in the parent document for easy reads
      const parentRef = doc(db, 'condominios', userData.condominioId, 'interes_modulos', selectedLockedModule);
      const parentSnap = await getDoc(parentRef);
      const currentCount = parentSnap.exists() ? (parentSnap.data().votosCount || 0) : 0;
      await setDoc(parentRef, { votosCount: currentCount + 1 }, { merge: true });

      setHasVoted(true);
    } catch (e) {
      console.error("Error saving interest vote:", e);
      alert("Error al registrar interés.");
    } finally {
      setVotingLoader(false);
    }
  };

  // ── Dynamic financial states ──────────────────
  const [saldoActual, setSaldoActual] = useState(0);
  const [proximoPagoVal, setProximoPagoVal] = useState('01 Oct');

  // ── Cargos y Saldos listener ─────────────────
  useEffect(() => {
    if (!currentUser?.uid || !userData?.condominioId || userData?.rol !== 'residente') return;

    let q;
    if (userData?.numeroCasa && userData.numeroCasa !== 'N/A') {
      q = query(
        collection(db, "cargos"),
        where("condominioId", "==", userData.condominioId),
        where("unidadResidente", "==", userData.numeroCasa)
      );
    } else {
      q = query(
        collection(db, "cargos"),
        where("residenteId", "==", currentUser.uid)
      );
    }

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaCargos = snapshot.docs.map(doc => doc.data());
      const totalPendiente = listaCargos
        .filter(c => c.estatus === 'pendiente' || c.estatus === 'parcial')
        .reduce((sum, c) => sum + (c.monto - (c.montoPagado || 0)), 0);
      
      setSaldoActual(totalPendiente);

      // Encontrar el próximo pago vencido o más próximo en el futuro
      const pendientes = listaCargos
        .filter(c => c.estatus === 'pendiente' || c.estatus === 'parcial')
        .map(c => {
          try {
            return c.fechaVencimiento?.toDate ? c.fechaVencimiento.toDate() : new Date(c.fechaVencimiento);
          } catch(e) {
            return null;
          }
        })
        .filter(Boolean)
        .sort((a, b) => a - b);

      if (pendientes.length > 0) {
        setProximoPagoVal(moment(pendientes[0]).format('DD MMM'));
      } else {
        setProximoPagoVal('Al corriente');
      }
    });

    return () => unsubscribe();
  }, [currentUser, userData]);

  // ── Carousel data ────────────────────────────
  const [avisos, setAvisos] = useState([]);
  const [amenidades, setAmenidades] = useState([]);

  // ── Camera permission pre-request ────────────
  useEffect(() => {
    const hasChecked = localStorage.getItem('kondo_safety_perms_checked');
    if (hasChecked === 'true') return; // Skip if checked once to prevent activating camera/microphone on every mount

    const requestSafetyPermissions = async () => {
      if (navigator.permissions && navigator.permissions.query) {
        try {
          const result = await navigator.permissions.query({ name: 'camera' });
          if (result.state === 'granted') {
            localStorage.setItem('kondo_safety_perms_checked', 'true');
            return;
          }
        } catch (e) { }
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
        stream.getTracks().forEach(track => track.stop());
        localStorage.setItem('kondo_safety_perms_checked', 'true');
      } catch (err) { }
    };
    requestSafetyPermissions();
  }, []);

  // ── Avisos carousel listener ─────────────────
  useEffect(() => {
    if (!userData?.condominioId) return;
    const q = query(
      collection(db, 'avisos'),
      where('condominioId', '==', userData.condominioId),
      orderBy('fechaCreacion', 'desc'),
      limit(6)
    );
    const unsub = onSnapshot(q, (snap) => {
      const rawAvisos = snap.docs.map(d => ({
        id: d.id,
        ...d.data(),
        fechaCreacion: d.data().fechaCreacion?.toDate?.() || new Date(),
      }));

      const filteredAvisos = rawAvisos.filter(a => {
        const aud = a.audiencia || 'todos';
        if (userData.rol === 'admin' || userData.rol === 'comite') return true;
        if (userData.rol === 'vigilante') return aud === 'todos' || aud === 'vigilantes';
        return aud === 'todos' || aud === 'residentes'; // residentes e inquilinos
      });

      const sorted = [...filteredAvisos].sort((a, b) => {
        const isAActiveAlert = a.esAlerta && a.fechaExpiracionAlerta && (
          (a.fechaExpiracionAlerta.toDate ? a.fechaExpiracionAlerta.toDate() : new Date(a.fechaExpiracionAlerta)) > new Date()
        );
        const isBActiveAlert = b.esAlerta && b.fechaExpiracionAlerta && (
          (b.fechaExpiracionAlerta.toDate ? b.fechaExpiracionAlerta.toDate() : new Date(b.fechaExpiracionAlerta)) > new Date()
        );
        if (isAActiveAlert && !isBActiveAlert) return -1;
        if (!isAActiveAlert && isBActiveAlert) return 1;
        return b.fechaCreacion - a.fechaCreacion;
      });

      setAvisos(sorted);
    }, (err) => console.error('Avisos carousel:', err));
    return () => unsub();
  }, [userData]);

  // ── Amenidades carousel listener ─────────────
  useEffect(() => {
    if (!userData?.condominioId) return;
    const q = query(
      collection(db, 'amenidades'),
      where('condominioId', '==', userData.condominioId)
    );
    const unsub = onSnapshot(q, (snap) => {
      setAmenidades(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    }, (err) => console.error('Amenidades carousel:', err));
    return () => unsub();
  }, [userData]);

  // ── SUPERUSER: Pending Global Validations ────
  useEffect(() => {
    if (!userData || (userData.rol !== 'superuser' && userData.rol !== 'masteruser')) return;
    const q = query(collection(db, 'market_proveedores'), where('estatus', '==', 'pendiente'));
    const unsub = onSnapshot(q, (snap) => { setPendingGlobalValidations(snap.size); }, (e) => console.error(e));
    return () => unsub();
  }, [userData]);

  // ── ADMIN/COMITE: Pending Items ───────────────
  useEffect(() => {
    if (!userData || !userData.condominioId) return;
    if (userData.rol !== 'admin' && userData.rol !== 'comite' && userData.rol !== 'masteruser') return;

    const unsubReports = onSnapshot(
      query(collection(db, 'reportes'), where('condominioId', '==', userData.condominioId), where('estatus', '==', 'Pendiente')),
      (snap) => setPendingReports(snap.size), (e) => console.error(e)
    );
    const unsubWall = onSnapshot(
      query(collection(db, 'muro_posts'), where('condominioId', '==', userData.condominioId), where('estatus', '==', 'pendiente')),
      (snap) => setPendingWallPosts(snap.size), (e) => console.error(e)
    );
    const unsubVehicles = onSnapshot(
      query(collection(db, 'vehiculos'), where('condominioId', '==', userData.condominioId), where('estatus', '==', 'pendiente')),
      (snap) => setPendingVehicles(snap.size), (e) => console.error(e)
    );
    const unsubProviders = onSnapshot(
      query(collection(db, 'market_proveedores'), where('condominioId', '==', userData.condominioId), where('estatus', '==', 'en_revision')),
      (snap) => setPendingProviders(snap.size), (e) => console.error(e)
    );
    return () => { unsubReports(); unsubWall(); unsubVehicles(); unsubProviders(); };
  }, [userData]);

  // ── Pending Approvals count ───────────────────
  useEffect(() => {
    if (!currentUser || !userData || !['admin', 'comite'].includes(userData.rol)) return;

    const q = query(
      collection(db, "gastos"),
      where("condominioId", "==", userData.condominioId),
      where("estatus", "==", "por_aprobar")
    );

    const unsub = onSnapshot(q, (snap) => {
      let count = 0;
      snap.docs.forEach(doc => {
        const data = doc.data();
        if (data.approvers && data.approvers.includes(currentUser.uid)) {
          count++;
        }
      });
      setPendingApprovals(count);
    }, (err) => console.error("Error fetching pending approvals:", err));

    return () => unsub();
  }, [currentUser, userData]);

  // ── RESIDENT/COMITE: Quotes & Polls ──────────
  useEffect(() => {
    if (!userData || !userData.condominioId || !currentUser) return;
    if (userData.rol !== 'residente' && userData.rol !== 'comite') return;

    // ── RESIDENT/COMITE: Quotes & Polls ──────────
    const unsubResQuotes = onSnapshot(
      query(collection(db, "cotizaciones"), where("residenteId", "==", currentUser.uid), where("estatus", "in", ["pendiente_residente", "cambio_fecha_solicitado"])),
      (snap) => setResPendingResponses(snap.size)
    );
    const qEncuestas = query(collection(db, "encuestas"), where("condominioId", "==", userData.condominioId));
    const unsubEncuestas = onSnapshot(qEncuestas, async (snap) => {
      let count = 0;
      const now = new Date();
      const tipoRes = (userData.tipoResidente || '').toLowerCase();
      for (const docSnap of snap.docs) {
        const enc = docSnap.data();
        // Verificar si no ha expirado
        if (enc.fechaFin) {
          const fFin = enc.fechaFin.toDate ? enc.fechaFin.toDate() : new Date(enc.fechaFin);
          if (fFin < now) continue;
        }
        const reg = enc.reglas || {};
        let eligible = true;
        if (reg.soloPropietarios && tipoRes !== 'propietario') eligible = false;
        if (!reg.permiteMorosos && isMoroso) eligible = false;
        if (eligible) {
          try {
            const votoSnap = await getDoc(doc(db, 'encuestas', docSnap.id, 'votos', currentUser.uid));
            if (!votoSnap.exists()) count++;
          } catch (e) {
            // Si no puede leer subcolección por permisos, sumar si está activa
            count++;
          }
        }
      }
      setPendingEncuestas(count);
    });
    return () => { unsubResQuotes(); unsubEncuestas(); };
  }, [userData, currentUser, isMoroso]);

  // ── ALL ROLES: Active / Upcoming Asambleas Listener ──
  useEffect(() => {
    if (!userData || !userData.condominioId) return;

    const qAsambleas = query(
      collection(db, 'asambleas'),
      where('condominioId', '==', userData.condominioId)
    );

    const unsub = onSnapshot(qAsambleas, (snap) => {
      let count = 0;
      snap.docs.forEach(docSnap => {
        const data = docSnap.data();
        if (data.estatus === 'en_vivo' || data.estatus === 'programada') {
          count++;
        }
      });
      setPendingAsambleas(count);
    }, (err) => console.warn('Error leyendo asambleas para badge:', err));

    return () => unsub();
  }, [userData]);

  // ── COMITE: Pending Licitaciones to Vote ───
  useEffect(() => {
    if (!userData || !userData.condominioId || !currentUser || userData.rol !== 'comite') return;

    const q = query(
      collection(db, 'licitaciones'),
      where('condominioId', '==', userData.condominioId),
      where('estatus', '==', 'pendiente')
    );

    const unsub = onSnapshot(q, (snap) => {
      let count = 0;
      snap.docs.forEach(docSnap => {
        const lic = docSnap.data();
        if (!lic.votos || !lic.votos[currentUser.uid]) {
          count++;
        }
      });
      setPendingLicitaciones(count);
    }, (e) => console.error('Error fetching pending licitaciones:', e));

    return () => unsub();
  }, [userData, currentUser]);

  // ── RESIDENT: Pending Convenios to Sign ───
  useEffect(() => {
    if (!userData || !userData.condominioId || !currentUser || userData.rol !== 'residente') return;

    const q = query(
      collection(db, 'convenios'),
      where('condominioId', '==', userData.condominioId),
      where('residenteId', '==', currentUser.uid),
      where('estatus', '==', 'pendiente_firma')
    );

    const unsub = onSnapshot(q, (snap) => {
      setPendingConvenios(snap.size);
    }, (e) => console.error('Error fetching pending convenios:', e));

    return () => unsub();
  }, [userData, currentUser]);

  // ── Unread Sanctions count ────────────────────
  useEffect(() => {
    if (!currentUser || !userData || userData.rol !== 'residente') return;
    const q = query(
      collection(db, "apercibimientos_multas"),
      where("residenteId", "==", currentUser.uid),
      where("leido", "==", false)
    );
    const unsub = onSnapshot(q, (snap) => {
      setPendingSanciones(snap.size);
    }, (err) => console.error("Error fetching pending sanctions:", err));
    return () => unsub();
  }, [currentUser, userData]);

  // ── Packages & Parking ───────────────────────
  useEffect(() => {
    if (!userData || !userData.condominioId) return;
    let unsubPackages = () => { };
    let unsubParking = () => { };

    if (['admin', 'comite', 'vigilante'].includes(userData?.rol)) {
      unsubParking = onSnapshot(
        query(collection(db, "estacionamientos_solicitudes"), where("condominioId", "==", userData.condominioId), where("estatus", "==", "pendiente")),
        (snap) => {
          setPendingParking(snap.size);
        },
        (e) => console.error("Error al contar solicitudes de estacionamiento:", e)
      );
    } else if (userData.numeroCasa || userData.residencia) {
      unsubParking = onSnapshot(
        query(collection(db, "estacionamientos"), where("condominioId", "==", userData.condominioId), where("estado", "==", "ocupado")),
        (snap) => {
          let c = 0;
          snap.docs.forEach(d => { const p = d.data(); if (p.casaVisita === userData.numeroCasa || p.casaVisita === userData.residencia) c++; });
          setPendingParking(c);
        }
      );

      unsubPackages = onSnapshot(
        query(collection(db, "paquetes"), where("condominioId", "==", userData.condominioId), where("estado", "==", "en_caseta")),
        (snap) => {
          let c = 0;
          snap.docs.forEach(d => { const p = d.data(); if (p.detallesCasa === userData.numeroCasa || p.detallesCasa === userData.residencia) c++; });
          setPendingPackages(c);
        }
      );
    }

    return () => { unsubPackages(); unsubParking(); };
  }, [userData]);

  // ── Provider ─────────────────────────────────
  const [provPendingQuotes, setProvPendingQuotes] = useState(0);
  const [provActiveServices, setProvActiveServices] = useState(0);

  useEffect(() => {
    if (!userData || !userData.proveedorId) return;
    const unsubQ = onSnapshot(
      query(collection(db, 'cotizaciones'), where('proveedorId', '==', userData.proveedorId), where('estatus', '==', 'pendiente')),
      (snap) => setProvPendingQuotes(snap.size)
    );
    const unsubA = onSnapshot(
      query(collection(db, 'cotizaciones'), where('proveedorId', '==', userData.proveedorId), where('estatus', 'in', ['pendiente_residente', 'aceptada', 'servicio_programado', 'proveedor_en_camino', 'proveedor_en_sitio', 'servicio_en_curso', 'esperando_aprobacion_final'])),
      (snap) => setProvActiveServices(snap.size)
    );
    return () => { unsubQ(); unsubA(); };
  }, [userData]);

  // ── Security Chat Badge ───────────────────────
  const [securityBadge, setSecurityBadge] = useState(0);
  useEffect(() => {
    if (!currentUser) return;
    const unsub = onSnapshot(
      query(collection(db, "chats"), where("participants", "array-contains", currentUser.uid)),
      (snap) => {
        let total = 0;
        snap.docs.forEach(d => { total += d.data()[`unread_${currentUser.uid}`] || 0; });
        setSecurityBadge(total);
      }
    );
    return () => unsub();
  }, [currentUser]);

  // ── Owner Pending Tenants ─────────────────────
  const [pendingTenantsBadge, setPendingTenantsBadge] = useState(0);
  useEffect(() => {
    if (!userData || !currentUser || userData.tipoResidente !== 'Propietario') return;
    const unsub = onSnapshot(
      query(collection(db, "usuarios"), where("cuentaPadreId", "==", currentUser.uid), where("estatusValidacion", "==", "pendiente")),
      (snap) => setPendingTenantsBadge(snap.size)
    );
    return () => unsub();
  }, [userData, currentUser]);

  // ── Global App Badge ──────────────────────────
  useEffect(() => {
    if (!userData) return;
    let total = 0;
    if (['admin', 'comite', 'masteruser'].includes(userData.rol)) total += pendingReports + pendingWallPosts + pendingVehicles + pendingProviders + pendingAsambleas;
    if (['residente', 'comite'].includes(userData.rol)) total += resPendingResponses + pendingEncuestas + pendingAsambleas + pendingConvenios + pendingSanciones;
    if (userData.rol === 'comite') total += pendingLicitaciones + pendingApprovals;
    if (userData.rol === 'proveedor' || userData.proveedorId) total += provPendingQuotes + provActiveServices;
    total += pendingPackages + pendingParking;
    
    // El badge de chat de seguridad / administración aplica para TODOS
    total += securityBadge;
    
    if (['superuser', 'masteruser'].includes(userData.rol)) total += pendingGlobalValidations;
    setGlobalBadgeCount(total);
    try {
      if ('setAppBadge' in navigator) {
        total > 0 ? navigator.setAppBadge(total) : navigator.clearAppBadge();
      }
    } catch (e) { }
  }, [userData, pendingReports, pendingWallPosts, pendingVehicles, pendingProviders, resPendingResponses, pendingEncuestas, pendingAsambleas, pendingConvenios, pendingSanciones, pendingApprovals, provPendingQuotes, provActiveServices, securityBadge, pendingLicitaciones, pendingPackages, pendingParking, pendingGlobalValidations]);

  // ── Handlers ─────────────────────────────────
  const handleLogout = async () => {
    try { await logout(); navigate('/login'); } catch (e) { console.error(e); }
  };

  const handleRestrictedAccess = (e) => {
    if (e) e.preventDefault();
    alert('Acceso denegado. Tienes adeudos pendientes, por favor ve a la sección "Pagar Cuota"');
    navigate('/pagar-cuota');
  };

  const handleContactAdmin = async () => {
    if (!userData?.condominioId) {
      alert("No perteneces a ningún condominio activo.");
      return;
    }
    try {
      const q = query(
        collection(db, "usuarios"),
        where("condominioId", "==", userData.condominioId),
        where("rol", "==", "admin"),
        limit(1)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const adminId = querySnapshot.docs[0].id;
        navigate(`/chat/${adminId}`);
      } else {
        const qComite = query(
          collection(db, "usuarios"),
          where("condominioId", "==", userData.condominioId),
          where("rol", "==", "comite"),
          limit(1)
        );
        const snapComite = await getDocs(qComite);
        if (!snapComite.empty) {
          const comiteId = snapComite.docs[0].id;
          navigate(`/chat/${comiteId}`);
        } else {
          alert("No se encontró ningún Administrador registrado para tu condominio en este momento. Por favor contacta al comité físico.");
        }
      }
    } catch (err) {
      console.error("Error finding administrator:", err);
      alert("Ocurrió un error al contactar con la administración.");
    }
  };

  const getPendingModules = () => {
    const modules = [];
    if (['admin', 'comite', 'masteruser'].includes(userData?.rol)) {
      if (pendingReports > 0) modules.push({ id: 'reports', name: 'Reportes', count: pendingReports, path: '/gestion-reportes', icon: <IoWarningOutline /> });
      if (pendingWallPosts > 0) modules.push({ id: 'wall', name: 'Muro (Moderación)', count: pendingWallPosts, path: '/admin/muro', icon: <IoChatbubblesOutline /> });
      if (pendingVehicles > 0) modules.push({ id: 'vehicles', name: 'Control Vehicular', count: pendingVehicles, path: '/gestion-vehiculos', icon: <IoCarSportOutline /> });
      if (pendingProviders > 0) modules.push({ id: 'providers', name: 'Validar Proveedores', count: pendingProviders, path: '/admin/validacion-proveedores', icon: <IoBriefcaseOutline /> });
      if (pendingAsambleas > 0) modules.push({ id: 'asambleas', name: 'Asambleas Activas', count: pendingAsambleas, path: '/admin/asambleas', icon: <IoStatsChartOutline /> });
    }
    if (['residente', 'comite'].includes(userData?.rol)) {
      if (resPendingResponses > 0) modules.push({ id: 'res_quotes', name: 'Marketplace', count: resPendingResponses, path: '/marketplace', icon: <IoStorefrontOutline /> });
      if (pendingEncuestas > 0) modules.push({ id: 'encuestas', name: 'Encuestas Pendientes', count: pendingEncuestas, path: '/encuestas', icon: <IoListCircleOutline /> });
      if (pendingAsambleas > 0) modules.push({ id: 'asambleas_res', name: 'Asamblea Programada / En Vivo', count: pendingAsambleas, path: '/asambleas', icon: <IoStatsChartOutline /> });
      if (pendingConvenios > 0) modules.push({ id: 'pending_convenios', name: 'Convenios por Firmar', count: pendingConvenios, path: '/convenios', icon: <IoDocumentTextOutline /> });
      if (pendingSanciones > 0) modules.push({ id: 'pending_sanciones', name: 'Nuevas Sanciones', count: pendingSanciones, path: '/apercibimientos', icon: <IoWarningOutline /> });
      if (userData?.rol === 'comite' && pendingLicitaciones > 0) {
        modules.push({ id: 'licitaciones', name: 'Licitaciones de Compra', count: pendingLicitaciones, path: '/licitaciones', icon: <IoDocumentTextOutline /> });
      }
    }
    if (pendingPackages > 0) modules.push({ id: 'packages', name: 'Paquetes en Caseta', count: pendingPackages, path: '/accesos', icon: <IoTicketOutline /> });
    if (pendingParking > 0) modules.push({ id: 'parking', name: 'Estacionamiento', count: pendingParking, path: '/estacionamientos', icon: <IoLocationOutline /> });
    if (userData?.rol === 'proveedor' || userData?.proveedorId) {
      if (provPendingQuotes > 0) modules.push({ id: 'prov_quotes', name: 'Nuevas Solicitudes', count: provPendingQuotes, path: '/proveedor/cotizaciones', icon: <IoBriefcaseOutline /> });
      if (provActiveServices > 0) modules.push({ id: 'prov_services', name: 'Mis Servicios Activos', count: provActiveServices, path: '/proveedor/servicios', icon: <IoListCircleOutline /> });
    }
    if (securityBadge > 0) {
      if (['admin', 'comite', 'masteruser'].includes(userData?.rol)) {
        modules.push({ id: 'security', name: 'Mensajes / Chats Activos', count: securityBadge, path: '/seguridad', icon: <IoShieldCheckmarkOutline /> });
      } else if (userData?.rol === 'residente') {
        modules.push({ id: 'security', name: 'Mensajes / Chats Activos', count: securityBadge, path: '/seguridad', icon: <IoShieldCheckmarkOutline /> });
      } else if (userData?.rol === 'vigilante') {
        modules.push({ id: 'security', name: 'Seguridad (Chats)', count: securityBadge, path: '/seguridad', icon: <IoShieldCheckmarkOutline /> });
      }
    }
    if (['superuser', 'masteruser'].includes(userData?.rol) && pendingGlobalValidations > 0) modules.push({ id: 'global_val', name: 'Validación Global', count: pendingGlobalValidations, path: '/superuser/validacion-proveedores', icon: <IoBriefcaseOutline /> });
    return modules;
  };

  // ─────────────────────────────────────────────
  //  ROLE RENDERERS
  // ─────────────────────────────────────────────

  const renderSaaSCard = ({ to, icon, title, subtitle, theme, badgeCount, moduleKey, onClick }) => {
    const isEnabled = isModuleEnabled(userData?.condoData, moduleKey);
    if (isEnabled) {
      return <HomeCard to={to} icon={icon} title={title} subtitle={subtitle} theme={theme} badgeCount={badgeCount} onClick={onClick} />;
    }

    const interestCount = votosInteres[moduleKey] || 0;
    const isResident = userData?.rol === 'residente';

    return (
      <div 
        className="ks-card saas-locked" 
        onClick={() => openLockedModuleModal(moduleKey)}
      >
        {!isResident && interestCount > 0 ? (
          <div className="ks-card-badge-votos">
            {interestCount} {interestCount === 1 ? 'voto' : 'votos'}
          </div>
        ) : (
          <div className="ks-card-badge-locked">
            <IoLockClosedOutline size={12} /> Bloqueado
          </div>
        )}
        <div className={`ks-card-icon ${theme}`}>{icon}</div>
        <div className="ks-card-body">
          <h3>{title}</h3>
        </div>
      </div>
    );
  };

  const renderResidenteDashboard = () => {
    const hasPermission = (key) => {
      if (userData?.tipoResidente === 'Propietario' || userData?.rol === 'admin' || userData?.rol === 'comite') return true;
      if (!userData?.permisosInquilino) return false;
      return userData.permisosInquilino[key] === true;
    };
    return (
      <>
        <div className="ks-section-label">Accesos Directos</div>
        <HomeCard to="/muro" icon={<IoChatbubblesOutline />} title="Muro Social" subtitle="Noticias vecinales" theme="theme-indigo" />
        <HomeCard to="/marketplace" icon={<IoStorefrontOutline />} title="Marketplace" subtitle="Servicios y productos" theme="theme-blue" badgeCount={resPendingResponses} />
        {hasPermission('accesos') && <HomeCard to="/accesos" icon={<IoTicketOutline />} title="Accesos" subtitle="Visitas y Paquetes" theme="theme-teal" badgeCount={pendingPackages} />}
        {hasPermission('estacionamientos') && renderSaaSCard({ to: "/estacionamientos", icon: <IoLocationOutline />, title: "Estacionamientos", subtitle: "Lugares de visita", theme: "theme-teal", badgeCount: pendingParking, moduleKey: "estacionamientos" })}
        <HomeCard to="/mis-reportes" icon={<IoWarningOutline />} title="Reportar" subtitle="Incidencias y quejas" theme="theme-red" />
        {renderSaaSCard({ to: "/seguridad", icon: <IoShieldCheckmarkOutline />, title: "Seguridad", subtitle: "Cámaras y Vigilancia", theme: "theme-gray", badgeCount: securityBadge, moduleKey: "seguridad" })}
        {hasPermission('cuotas') && <HomeCard to="/pagar-cuota" icon={<IoWalletOutline />} title="Pagar Cuota" subtitle="Pagos y adeudos" theme="theme-green" />}
        <HomeCard to="/votaciones" icon={<IoStatsChartOutline />} title="Votaciones y Asambleas" subtitle="Consultas y juntas virtuales" theme="theme-indigo" badgeCount={pendingEncuestas + pendingAsambleas} />
        {hasPermission('vehiculos') && <HomeCard to="/vehiculos" icon={<IoCarSportOutline />} title="Mis Vehículos" subtitle="Registro de autos" theme="theme-black" />}
        <HomeCard to="/mascotas" icon={<IoPawOutline />} title="Mis Mascotas" subtitle="Censo de mascotas" theme="theme-orange" />
        {renderSaaSCard({ to: "/apercibimientos", icon: <IoBanOutline />, title: "Mis Sanciones", subtitle: "Historial de multas", theme: "theme-red", badgeCount: pendingSanciones, moduleKey: "apercibimientos" })}
        <HomeCard to="/convenios" icon={<IoDocumentTextOutline />} title="Mis Convenios" subtitle="Planes de pago" theme="theme-green" badgeCount={pendingConvenios} />
        <HomeCard to="/documentos" icon={<IoFolderOpenOutline />} title="Documentación" subtitle="Reglamentos, actas y finanzas" theme="theme-blue" />

        {userData?.proveedorId && (
          <>
            <div className="ks-section-label">Panel de Proveedor</div>
            <HomeCard to="/proveedor/cotizaciones" icon={<IoBriefcaseOutline />} title="Solicitudes" subtitle="Cotizaciones recibidas" theme="theme-purple" badgeCount={provPendingQuotes} />
            <HomeCard to="/proveedor/servicios" icon={<IoListCircleOutline />} title="Mis Servicios" subtitle="Agenda y seguimiento" theme="theme-purple" badgeCount={provActiveServices} />
            <HomeCard to="/proveedor/calendario" icon={<IoCalendarOutline />} title="Mi Calendario" subtitle="Gestionar agenda" theme="theme-orange" />
            <HomeCard to="/proveedor/suscripcion" icon={<IoCardOutline />} title="Gestionar Plan" subtitle="Gestionar plan" theme="theme-purple" />
          </>
        )}
      </>
    );
  };

  const renderProveedorDashboard = () => (
    <>
      <HomeCard to="/proveedor/cotizaciones" icon={<IoBriefcaseOutline />} title="Cotizaciones" subtitle="Nuevas solicitudes" theme="theme-blue" badgeCount={provPendingQuotes} />
      <HomeCard to="/proveedor/servicios" icon={<IoListCircleOutline />} title="Mis Servicios" subtitle="Historial y agenda" theme="theme-blue" badgeCount={provActiveServices} />
      <HomeCard to="/proveedor/calendario" icon={<IoCalendarOutline />} title="Mi Calendario" subtitle="Gestionar agenda" theme="theme-orange" />
      <HomeCard to="/proveedor/suscripcion" icon={<IoCardOutline />} title="Gestionar Plan" subtitle="Gestionar plan" theme="theme-blue" />
    </>
  );

  const renderAdminDashboard = () => (
    <>
      <div className="ks-section-label">Panel Administrativo</div>
      <HomeCard to="/gestion-avisos" icon={<IoMegaphoneOutline />} title="Publicar Avisos" subtitle="Notificar residentes" theme="theme-indigo" />
      {renderSaaSCard({ to: "/licitaciones", icon: <IoBriefcaseOutline />, title: "Licitaciones de Compra", subtitle: "Votar y evaluar cotizaciones", theme: "theme-blue", moduleKey: "licitaciones" })}
      <HomeCard to="/admin/votaciones" icon={<IoStatsChartOutline />} title="Votaciones y Asambleas" subtitle="Consultas y juntas virtuales" theme="theme-orange" badgeCount={pendingAsambleas} />
      <HomeCard to="/admin/muro" icon={<IoChatbubblesOutline />} title="Moderación Muro" subtitle="Aprobar publicaciones" theme="theme-purple" badgeCount={pendingWallPosts} />
      <HomeCard to="/gestion-reportes" icon={<IoWarningOutline />} title="Reportes" subtitle="Gestionar reportes" theme="theme-red" badgeCount={pendingReports} />
      <HomeCard to="/gestion-vehiculos" icon={<IoCarSportOutline />} title="Control Vehicular" subtitle="Validar accesos" theme="theme-teal" badgeCount={pendingVehicles} />
      <HomeCard to="/admin/validacion-proveedores" icon={<IoStorefrontOutline />} title="Solicitudes Mkt." subtitle="Validar proveedores" theme="theme-purple" badgeCount={pendingProviders} />
      {renderSaaSCard({ to: "/estacionamientos", icon: <IoLocationOutline />, title: "Estacionamientos", subtitle: "Control de cajones", theme: "theme-blue", badgeCount: pendingParking, moduleKey: "estacionamientos" })}
      {renderSaaSCard({ to: "/paqueteria", icon: <IoCubeOutline />, title: "Paquetería", subtitle: "Lokers y envíos", theme: "theme-indigo", moduleKey: "paqueteria" })}
      <HomeCard to="/admin/accesos" icon={<IoLockOpenOutline />} title="Accesos Condominio" subtitle="Plumas y Portones" theme="theme-teal" />
      {renderSaaSCard({ to: "/seguridad", icon: <IoShieldCheckmarkOutline />, title: "Seguridad", subtitle: "Control y vigilancia", theme: "theme-black", badgeCount: securityBadge, moduleKey: "seguridad" })}
      {renderSaaSCard({ to: "/apercibimientos", icon: <IoBanOutline />, title: "Apercibimientos", subtitle: "Historial sanciones", theme: "theme-red", moduleKey: "apercibimientos" })}

      <div className="ks-section-label">Finanzas y Pagos</div>
      <HomeCard to="/gestion-cuotas" icon={<IoCashOutline />} title="Gestión de Cuotas" subtitle="Cargos y cobranza" theme="theme-green" />
      <HomeCard to="/gestion-finanzas" icon={<IoAnalyticsOutline />} title="Reportes Financieros" subtitle="Ingresos y egresos" theme="theme-indigo" />
      <HomeCard to="/finanzas/banco" icon={<IoWalletOutline />} title="Bancos" subtitle="Conciliación bancaria" theme="theme-teal" />
      <HomeCard to="/obligaciones-fiscales" icon={<IoFileTrayFullOutline />} title="Declaraciones y SAT" subtitle="Cruce de IVA, ISR e IMSS" theme="theme-blue" />
      <HomeCard onClick={() => navigate('/gestion-facturas', { state: { viewContext: 'gastos' } })} icon={<IoReceiptOutline />} title="Facturas y Gastos" subtitle="Fiscal e Impuestos" theme="theme-red" />
      {renderSaaSCard({ to: "/nominas-dashboard", icon: <IoPeopleOutline />, title: "Nóminas", subtitle: "Recursos Humanos", theme: "theme-orange", moduleKey: "nominas-dashboard" })}
      <HomeCard to="/convenios" icon={<IoDocumentTextOutline />} title="Convenios" subtitle="Acuerdos de pago" theme="theme-purple" />

      <div className="ks-section-label">Administración del Condominio</div>
      <HomeCard to="/bitacora" icon={<IoListCircleOutline />} title="Bitácora Accesos" subtitle="Registro global" theme="theme-teal" />
      <HomeCard to="/gestion-usuarios" icon={<IoPeopleOutline />} title="Usuarios" subtitle="Directorio general" theme="theme-purple" />
      <HomeCard to="/admin/mascotas" icon={<IoPawOutline />} title="Padrón Mascotas" subtitle="Censo del fraccionamiento" theme="theme-orange" />
      <HomeCard to="/documentos" icon={<IoFolderOpenOutline />} title="Documentos Oficiales" subtitle="Biblioteca del desarrollo" theme="theme-blue" />
      <HomeCard to="/gestion-amenidades" icon={<IoConstructOutline />} title="Amenidades" subtitle="Espacios comunes" theme="theme-orange" />
      <HomeCard to="/configuracion-condominio" icon={<IoSettingsOutline />} title="Configuración" subtitle="SAT y Pagos" theme="theme-gray" />
    </>
  );

  const renderSuperuserDashboard = () => {
    return (
      <>
        <HomeCard to="/superuser/empresa" icon={<IoBusinessOutline />} title="Perfil Corporativo" subtitle="Mi Empresa, Bancos y Firma" theme="theme-indigo" />
        <HomeCard to="/superuser/validacion-proveedores" icon={<IoBriefcaseOutline />} title="Validación Global" subtitle="Proveedores externos" theme="theme-purple" badgeCount={pendingGlobalValidations} />
        <HomeCard to="/superuser/dashboard" icon={<IoReceiptOutline />} title="Facturación SaaS" subtitle="Control global" theme="theme-gray" />
        <HomeCard to="/superuser/accounting" icon={<IoBusinessOutline />} title="Accounting SaaS" subtitle="Finanzas Internas" theme="theme-indigo" />
        <HomeCard to="/superuser/crm" icon={<IoPeopleOutline />} title="SaaS CRM Central" subtitle="Control 360 Condominios" theme="theme-teal" />
        <HomeCard to="/superuser/marketplace" icon={<IoStorefrontOutline />} title="Marketplace B2B" subtitle="Red Proveedores" theme="theme-orange" />
        <HomeCard to="/superuser/marketplace/categorias" icon={<IoListCircleOutline />} title="Rubros Marketplace" subtitle="Directorios" theme="theme-orange" />
        <HomeCard to="/superuser/analytics" icon={<IoAnalyticsOutline />} title="Inteligencia de Negocio" subtitle="SaaS Analytics" theme="theme-red" />
        <HomeCard to="/superuser/projections" icon={<IoCalculatorOutline />} title="Proyecciones P&L" subtitle="Simulador Financiero" theme="theme-teal" />
        <HomeCard to="/superuser/market-planes" icon={<IoCalendarOutline />} title="Tiers Marketplace" subtitle="Cuotas y comisiones" theme="theme-red" />
        <HomeCard to="/superuser/hr/dashboard" icon={<IoPeopleOutline />} title="RH y nóminas" subtitle="RRHH Corporativo" theme="theme-purple" />
      </>
    );
  };

  const renderComiteAdminTools = () => (
    <>
      <div className="ks-section-label">Herramientas de Comité</div>
      <HomeCard to="/gestion-finanzas" icon={<IoDocumentTextOutline />} title="Transparencia" subtitle="Estados financieros" theme="theme-green" />
      {renderSaaSCard({ to: "/licitaciones", icon: <IoDocumentTextOutline />, title: "Licitaciones de Compra", subtitle: "Votar y evaluar cotizaciones", theme: "theme-indigo", badgeCount: pendingLicitaciones, moduleKey: "licitaciones" })}
      <HomeCard to="/admin/votaciones" icon={<IoStatsChartOutline />} title="Votaciones y Asambleas" subtitle="Consultas y juntas virtuales" theme="theme-indigo" badgeCount={pendingAsambleas + pendingEncuestas} />
      <HomeCard to="/admin/muro" icon={<IoChatbubblesOutline />} title="Moderación Muro" subtitle="Aprobar publicaciones" theme="theme-indigo" badgeCount={pendingWallPosts} />
      <HomeCard onClick={() => navigate('/gestion-facturas', { state: { viewContext: 'aprobaciones' } })} icon={<IoReceiptOutline />} title="Aprobaciones" subtitle="Autorizar Gastos" theme="theme-green" badgeCount={pendingApprovals} />
      <HomeCard to="/gestion-reportes" icon={<IoWarningOutline />} title="Reportes" subtitle="Supervisar incidencias" theme="theme-red" badgeCount={pendingReports} />
      {renderSaaSCard({ to: "/apercibimientos", icon: <IoWarningOutline />, title: "Apercibimientos", subtitle: "Historial sanciones", theme: "theme-red", moduleKey: "apercibimientos" })}
      <HomeCard to="/convenios" icon={<IoDocumentTextOutline />} title="Convenios" subtitle="Acuerdos de pago" theme="theme-green" />
      <HomeCard to="/configuracion-condominio" icon={<IoSettingsOutline />} title="Configuración" subtitle="Reglas y límites" theme="theme-gray" />
      <HomeCard to="/gestion-usuarios" icon={<IoPeopleOutline />} title="Directorio" subtitle="Ver residentes" theme="theme-gray" />
      {renderSaaSCard({ to: "/paqueteria?mode=admin", icon: <IoCubeOutline />, title: "Paquetería", subtitle: "Lokers y envíos", theme: "theme-teal", moduleKey: "paqueteria" })}
      <HomeCard to="/admin/accesos" icon={<IoLockOpenOutline />} title="Accesos Condominio" subtitle="Plumas y Portones" theme="theme-teal" />
      <HomeCard to="/bitacora" icon={<IoListCircleOutline />} title="Bitácora Accesos" subtitle="Registro global" theme="theme-teal" />
    </>
  );

  // Show carousels for non-superuser roles in a condo
  const showCarousels = userData?.condominioId && userData.condominioId !== 'GLOBAL' &&
    !['superuser', 'proveedor'].includes(userData?.rol);

  // ──────────────────────────────────────────────
  //  RENDER
  // ──────────────────────────────────────────────
  return (
    <div className="ks-page">

      {/* ── DESKTOP SIDEBAR ─────────────────────── */}
      <KondoSidebar activeRoute="/" />

      {/* ── MAIN AREA ────────────────────────────── */}
      <main className="ks-main">
        <div className="ks-scroll-area">
          <div className="ks-home-header-sticky-wrapper">
            <div className="native-safe-area-top" style={{ background: 'var(--kondo-purple)', height: '44px', display: 'block' }} />
            <div className="ks-top-bar">
              <div className="ks-top-bar-left">
                <div className="home-avatar-wrapper ks-top-avatar" onClick={() => navigate('/perfil')}>
                  {userData?.fotoPerfilUrl ? (
                    <AvatarViewer avatarUrl={userData.fotoPerfilUrl} className="home-profile-avatar" size={32} />
                  ) : (
                    <div className="home-profile-avatar-placeholder ks-top-avatar-placeholder">
                      <IoPersonCircleOutline size={32} color="#6348D1" />
                    </div>
                  )}
                </div>
                <div className="ks-top-greeting">
                  <span className="ks-top-saludo">¡Hola,</span>
                  <span className="ks-top-nombre">{userData?.nombre?.split(' ')[0] || 'Usuario'}!</span>
                </div>
              </div>

              <div className="ks-top-bar-right">
                {(userData?.rol === 'masteruser' || (userData?.rol === 'superuser' && userData?.condominioId !== 'GLOBAL')) && (
                  <button onClick={() => navigate('/superuser/master-portal')} className="ks-top-icon-btn" title="Cambiar Portal">
                    <IoAppsOutline size={20} color="#6348D1" />
                  </button>
                )}
                <button onClick={() => setShowNotifications(true)} className="ks-top-icon-btn" title="Notificaciones" style={{ position: 'relative' }}>
                  <IoNotificationsOutline size={22} color="#1A1D21" />
                  {globalBadgeCount > 0 && (
                    <span className="ks-top-badge">{globalBadgeCount > 99 ? '99+' : globalBadgeCount}</span>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* ── HERO CARD (gradient purple) ─────────── */}
          <div className="ks-hero-card-wrap">
            <div className="ks-hero-card">

              {/* Top row: Condo name + Status chip */}
              <div className="ks-hero-brand-row">
                <div className="ks-hero-logo-wrap">
                  <img src={kondifyLogo} alt="Kondify" className="ks-hero-full-logo" />
                  <h2 className="ks-hero-condo-name">
                    {userData?.condominioNombre || userData?.fraccionamiento || 'Mi Condominio'}
                  </h2>
                </div>

                <div className="ks-hero-status-group">
                  {/* Unit badge for residents */}
                  {userData?.rol === 'residente' && (
                    <span className="ks-hero-unit-chip">
                      <IoHomeOutline size={12} />
                      {userData?.numeroCasa || 'N/A'}
                    </span>
                  )}
                  {userData?.rol !== 'residente' && (
                    <span className="ks-hero-unit-chip" style={{ textTransform: 'capitalize' }}>
                      {userData?.rol}
                    </span>
                  )}
                  {userData?.rol === 'vigilante' && (
                    userData?.enTurno ? (
                      <button 
                        className="ks-hero-status-chip success" 
                        onClick={(e) => { e.stopPropagation(); handleToggleTurno(); }}
                        style={{ cursor: 'pointer', border: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px', outline: 'none' }}
                      >
                        <IoShieldCheckmarkOutline size={13} /> En Turno
                      </button>
                    ) : (
                      <button 
                        className="ks-hero-status-chip danger" 
                        onClick={(e) => { e.stopPropagation(); handleToggleTurno(); }}
                        style={{ cursor: 'pointer', border: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px', outline: 'none' }}
                      >
                        <IoWarningOutline size={13} /> Fuera de Turno
                      </button>
                    )
                  )}
                  {/* Payment status */}
                  {userData?.rol === 'residente' && (
                    hasConvenio ? (
                      <button className="ks-hero-status-chip info" style={{ backgroundColor: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', display: 'inline-flex', alignItems: 'center', gap: '4px' }} onClick={(e) => { e.stopPropagation(); navigate('/convenios'); }}>
                        🤝 Convenio
                      </button>
                    ) : isMoroso ? (
                      <button className="ks-hero-status-chip danger" onClick={(e) => { e.stopPropagation(); navigate('/pagar-cuota'); }}>
                        <IoWarningOutline size={13} /> Moroso
                      </button>
                    ) : (
                      <span className="ks-hero-status-chip success">
                        <IoShieldCheckmarkOutline size={13} /> Al Corriente
                      </span>
                    )
                  )}
                </div>
              </div>

              {/* Financial stat chips (residente only) */}
              {userData?.rol === 'residente' && (
                <div className="ks-hero-stats-row">
                  {userData?.saldoFavor > 0 ? (
                    <div className="ks-stat-chip" onClick={() => navigate('/pagar-cuota')}>
                      <span className="ks-stat-label">SALDO A FAVOR</span>
                      <span className="ks-stat-value" style={{ color: '#10B981', fontWeight: '800' }}>
                        ${new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(userData.saldoFavor)}
                      </span>
                    </div>
                  ) : (
                    <div className="ks-stat-chip" onClick={() => navigate('/pagar-cuota')}>
                      <span className="ks-stat-label">SALDO ACTUAL</span>
                      <span className="ks-stat-value">
                        ${new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(saldoActual)}
                      </span>
                    </div>
                  )}
                  <div className="ks-stat-chip" onClick={() => navigate('/pagar-cuota')}>
                    <span className="ks-stat-label">PRÓXIMO PAGO</span>
                    <span className="ks-stat-value">{proximoPagoVal}</span>
                  </div>
                </div>
              )}

              {/* For non-residente roles: just show a subtle row with pending tasks count */}
              {userData?.rol !== 'residente' && globalBadgeCount > 0 && (
                <div className="ks-hero-stats-row">
                  <div className="ks-stat-chip" onClick={() => setShowNotifications(true)} style={{ gridColumn: '1 / -1' }}>
                    <span className="ks-stat-label">TAREAS PENDIENTES</span>
                    <span className="ks-stat-value">{globalBadgeCount} por atender</span>
                  </div>
                </div>
              )}

            </div>
          </div>


          {/* ── AVISOS CAROUSEL (below hero, mobile-first) ── */}
          {showCarousels && (
            <AvisosCarousel
              avisos={avisos}
              actionLabel={['admin', 'comite'].includes(userData?.rol) ? 'Gestionar' : 'Ver todos'}
              onVerTodos={() => navigate(['admin', 'comite'].includes(userData?.rol) ? '/gestion-avisos' : '/avisos')}
            />
          )}

          {/* ── MODULE GRID ──────────────────────── */}
          <div className="ks-content-area">
            <div className="ks-modules-grid">
              {userData?.rol === 'residente' && renderResidenteDashboard()}
              {userData?.rol === 'comite' && (<>{renderResidenteDashboard()}{renderComiteAdminTools()}</>)}
              {userData?.rol === 'admin' && (<>{renderResidenteDashboard()}{renderAdminDashboard()}</>)}
              {userData?.rol === 'proveedor' && renderProveedorDashboard()}
              {userData?.rol === 'vigilante' && (
                <>
                  {renderSaaSCard({ to: "/seguridad", icon: <IoShieldCheckmarkOutline />, title: "Seguridad", subtitle: "Control de accesos", theme: "theme-gray", moduleKey: "seguridad", badgeCount: securityBadge })}
                  {renderSaaSCard({ to: "/paqueteria", icon: <IoArchiveOutline />, title: "Lockers", subtitle: "Recepción y entrega", theme: "theme-blue", moduleKey: "paqueteria" })}
                  {renderSaaSCard({ to: "/estacionamientos", icon: <IoCarSportOutline />, title: "Estacionamientos", subtitle: "Gestión de Visitas", theme: "theme-teal", badgeCount: pendingParking, moduleKey: "estacionamientos" })}
                  <HomeCard to="/admin/accesos" icon={<IoLockOpenOutline />} title="Accesos Condominio" subtitle="Plumas y Portones" theme="theme-gray" />
                </>
              )}
              {userData?.rol === 'superuser' && renderSuperuserDashboard()}
              {userData?.rol === 'masteruser' && (
                (!userData?.condominioId || userData?.condominioId === 'GLOBAL')
                  ? renderSuperuserDashboard()
                  : (
                    <>
                      {renderResidenteDashboard()}
                      {renderAdminDashboard()}
                      <HomeCard onClick={() => navigate('/gestion-facturas', { state: { viewContext: 'aprobaciones' } })} icon={<IoReceiptOutline />} title="Aprobaciones (Comité)" subtitle="Autorizar Gastos" theme="theme-green" badgeCount={pendingApprovals} />
                      <HomeCard to="/configuracion-condominio" icon={<IoSettingsOutline />} title="Reglas y Límites" subtitle="Config. del Comité" theme="theme-gray" />
                    </>
                  )
              )}
            </div>
          </div>

          {/* ── AMENIDADES CAROUSEL (above bottom nav) ── */}
          {showCarousels && (
            <AmenidadesCarousel
              amenidades={amenidades}
              onExplorar={() => navigate('/reservar')}
            />
          )}

        </div>

        {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
        <KondoBottomNav activeRoute="/" />

      </main>

      {/* ── NOTIFICATION MODAL ───────────────────── */}
      {showNotifications && (
        <div className="notifications-overlay" onClick={() => setShowNotifications(false)}>
          <div className="notifications-modal" onClick={e => e.stopPropagation()}>
            <div className="notifications-modal-header">
              <h2>Tareas Pendientes</h2>
              <button className="close-modal-btn" onClick={() => setShowNotifications(false)}>
                <IoCloseOutline size={24} />
              </button>
            </div>
            <div className="notifications-list">
              {getPendingModules().length === 0 ? (
                <div className="no-notifications">
                  <div style={{ padding: '20px', background: '#f4f2ff', borderRadius: '50%', marginBottom: '12px' }}>
                    <IoNotificationsOutline size={40} color="#6348D1" />
                  </div>
                  <p>¡Todo limpio! No tienes tareas pendientes.</p>
                </div>
              ) : (
                getPendingModules().map(mod => (
                  <div key={mod.id} className="notification-item"
                    onClick={() => { setShowNotifications(false); navigate(mod.path); }}>
                    <div className="notif-icon-box">{mod.icon}</div>
                    <div className="notif-content">
                      <strong>{mod.name}</strong>
                      <span>{mod.count} pendiente{mod.count > 1 ? 's' : ''}</span>
                    </div>
                    <IoArrowForward color="#9ca3af" style={{ marginLeft: 'auto' }} />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      )}
      {/* ── SaaS LOCKED MODULE DETAILS MODAL ────── */}
      {showLockedModal && selectedLockedModule && (() => {
        const info = getModuleInfo(selectedLockedModule);
        const isResident = userData?.rol === 'residente';
        const totalVotos = votosInteres[selectedLockedModule] || 0;

        return (
          <div className="notifications-overlay" onClick={() => setShowLockedModal(false)}>
            <div className="notifications-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
              <div className="notifications-modal-header" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ background: '#e0e7ff', padding: '8px', borderRadius: '10px', display: 'flex' }}>
                    <IoLockClosedOutline size={22} color="#4f46e5" />
                  </div>
                  <div>
                    <h2 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#1e293b', margin: 0 }}>{info.title}</h2>
                    <span style={{ fontSize: '0.75rem', color: '#8b5cf6', fontWeight: 'bold' }}>Módulo Premium</span>
                  </div>
                </div>
                <button className="close-modal-btn" onClick={() => setShowLockedModal(false)}>
                  <IoCloseOutline size={24} />
                </button>
              </div>

              <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '18px' }}>
                <p style={{ fontSize: '0.92rem', color: '#475569', lineHeight: '1.5', margin: 0 }}>
                  {info.description}
                </p>

                <div>
                  <h4 style={{ margin: '0 0 8px', fontSize: '0.88rem', fontWeight: 'bold', color: '#0f172a' }}>Beneficios clave:</h4>
                  <ul style={{ margin: 0, paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {info.benefits.map((b, idx) => (
                      <li key={idx} style={{ fontSize: '0.88rem', color: '#475569' }}>{b}</li>
                    ))}
                  </ul>
                </div>

                {isResident ? (
                  <div style={{ marginTop: '10px', background: '#f8fafc', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', textAlign: 'center' }}>
                    <p style={{ margin: '0 0 12px', fontSize: '0.85rem', color: '#64748b' }}>
                      Este módulo no ha sido contratado por la administración de tu fraccionamiento. Registra tu interés para hacérselo saber al comité.
                    </p>
                    {hasVoted ? (
                      <button
                        disabled
                        style={{
                          width: '100%', padding: '12px', borderRadius: '10px',
                          background: '#10b981', color: 'white', border: 'none',
                          fontWeight: 'bold', fontSize: '0.9rem', cursor: 'not-allowed'
                        }}
                      >
                        ✓ ¡Interés registrado!
                      </button>
                    ) : (
                      <button
                        onClick={handleRegisterInterest}
                        disabled={votingLoader}
                        style={{
                          width: '100%', padding: '12px', borderRadius: '10px',
                          background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                          color: 'white', border: 'none', fontWeight: 'bold',
                          fontSize: '0.9rem', cursor: 'pointer', transition: 'opacity 0.2s'
                        }}
                      >
                        {votingLoader ? 'Registrando...' : 'Me interesa este módulo'}
                      </button>
                    )}
                  </div>
                ) : (
                  <div style={{ marginTop: '10px', background: '#faf5ff', padding: '15px', borderRadius: '12px', border: '1px solid #f3e8ff', textAlign: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '5px', alignItems: 'center', marginBottom: '8px' }}>
                      <span style={{ fontSize: '0.85rem', color: '#6b21a8', fontWeight: 'bold' }}>
                        {totalVotos} {totalVotos === 1 ? 'propiedad interesada' : 'propiedades interesadas'}
                      </span>
                    </div>
                    <p style={{ margin: '0 0 15px', fontSize: '0.85rem', color: '#6b7280' }}>
                      Puedes activar este módulo poniéndose en contacto con nuestro equipo de ventas y soporte de Kondify.
                    </p>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <a
                        href={`https://wa.me/5216641234567?text=Hola,%20nos%20interesa%20contratar%20el%20modulo%20de%20${encodeURIComponent(info.title)}%20para%20el%20fraccionamiento%20${encodeURIComponent(userData?.condominioNombre || '')}.%20Tenemos%20${totalVotos}%20propiedades%20interesadas.`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          flex: 1, padding: '12px', borderRadius: '10px',
                          background: '#25d366', color: 'white', textDecoration: 'none',
                          fontWeight: 'bold', fontSize: '0.88rem', display: 'inline-block',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                      >
                        WhatsApp
                      </a>
                      <a
                        href={`mailto:soporte@kondify.mx?subject=Interes%20en%20contratacion%20de%20modulo%20${encodeURIComponent(info.title)}&body=Hola,%20nos%20interesa%20contratar%20el%20modulo%20de%20${encodeURIComponent(info.title)}%20para%20el%20fraccionamiento%20${encodeURIComponent(userData?.condominioNombre || '')}.%20Actualmente%20tenemos%20${totalVotos}%20propiedades%20interesadas.`}
                        style={{
                          flex: 1, padding: '12px', borderRadius: '10px',
                          background: '#4f46e5', color: 'white', textDecoration: 'none',
                          fontWeight: 'bold', fontSize: '0.88rem', display: 'inline-block',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                      >
                        Enviar Correo
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })()}
      {turnoConfirmModal.show && (
        <div className="modal-overlay" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10000, padding: '20px' }}>
          <div className="modal-content" style={{ backgroundColor: '#ffffff', borderRadius: '24px', padding: '28px', maxWidth: '420px', width: '100%', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <div style={{ backgroundColor: turnoConfirmModal.isEntering ? '#ecfdf5' : '#fff5f5', borderRadius: '50%', padding: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: turnoConfirmModal.isEntering ? '#10b981' : '#ef4444' }}>
              <IoShieldCheckmarkOutline size={40} />
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#1e293b', margin: '0 0 12px 0', fontFamily: 'Manrope, sans-serif' }}>
              {turnoConfirmModal.isEntering ? "Iniciar Turno de Vigilancia" : "Terminar Turno de Vigilancia"}
            </h3>
            <p style={{ fontSize: '0.92rem', color: '#64748b', lineHeight: '1.5', margin: '0 0 24px 0' }}>
              {turnoConfirmModal.isEntering 
                ? "¿Confirmas que deseas iniciar tu turno y empezar a recibir las notificaciones de accesos y visitas?" 
                : "¿Confirmas que deseas finalizar tu turno de vigilancia?"}
            </p>
            <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
              <button
                onClick={() => setTurnoConfirmModal({ show: false, isEntering: false })}
                style={{ flex: 1, backgroundColor: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '16px', padding: '14px 24px', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                onClick={confirmToggleTurno}
                style={{ flex: 1, backgroundColor: '#7B61FF', color: '#ffffff', border: 'none', borderRadius: '16px', padding: '14px 24px', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer', boxShadow: '0 4px 6px -1px rgba(123, 97, 255, 0.2)' }}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {turnoSuccessModal.show && (
        <div className="modal-overlay" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10000, padding: '20px' }}>
          <div className="modal-content" style={{ backgroundColor: '#ffffff', borderRadius: '24px', padding: '28px', maxWidth: '420px', width: '100%', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <div style={{ backgroundColor: '#ecfdf5', borderRadius: '50%', padding: '16px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981' }}>
              <IoShieldCheckmarkOutline size={40} />
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '800', color: '#1e293b', margin: '0 0 12px 0', fontFamily: 'Manrope, sans-serif' }}>Acción Exitosa</h3>
            <p style={{ fontSize: '0.92rem', color: '#64748b', lineHeight: '1.5', margin: '0 0 24px 0' }}>
              {turnoSuccessModal.message}
            </p>
            <button
              onClick={() => setTurnoSuccessModal({ show: false, message: '' })}
              style={{ backgroundColor: '#7B61FF', color: '#ffffff', border: 'none', borderRadius: '16px', padding: '14px 24px', fontWeight: '700', fontSize: '0.95rem', cursor: 'pointer', width: '100%', boxShadow: '0 4px 6px -1px rgba(123, 97, 255, 0.2)' }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomeScreen;